import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Company } from '@app/models/company/company.model';
import { JobBoard } from '@app/models/recruiting/job-board.model';

@Injectable()
export class JobBoardService {
    private apiBaseUrl = '/v2/applicantTracker';

    constructor(private httpClient: HttpClient) {}

    async getBoard(company: Company): Promise<JobBoard> {
        const url = `${this.apiBaseUrl}/companies/${company.id}/board`;
        const board = await this.httpClient.get(url).toPromise();

        return board ? new JobBoard(board) : new JobBoard();
    }
}
